import { IHtmlTagConfig } from "@pjs/security";

export const ulConfig: IHtmlTagConfig = {
    attributes: null,
    styles: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "list-style-type": (value) => (/^(disc|circle|square)$/.test(value) ? value : "")
    }
};
